module.exports = __webpack_public_path__ + "static/media/picture-(190).468d9e39.JPG";